(() => {
  if (customElements.get('njt-product-purchase')) return;
  class ProductPurchase extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.root = document.getElementById('MainProduct-' + this.dataset.section);
      if (!this.root) return;
      this.info = this.root.querySelector('product-info');
      this.form = document.getElementById('product-form-' + this.dataset.section);
      this.main = document.getElementById('ProductSubmitButton-' + this.dataset.section);
      if (!this.form || !this.main) return;
      this.bar = this.querySelector('[data-njt-sticky]');
      this.add = this.querySelector('[data-njt-sticky-add]');
      this.price = this.querySelector('[data-njt-sticky-price]');
      this.variants = JSON.parse(this.querySelector('[data-njt-purchase-variants]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-njt-purchase-labels]').textContent);
      const quantity = document.getElementById('Quantity-Form-' + this.dataset.section);
      if (quantity) {
        const row = document.createElement('div');
        row.className = 'njt-purchase-row';
        this.main.before(row);
        row.append(quantity, this.main);
      }
      this.arrangeDetails();
      this.add.addEventListener('click', () => {
        this.sync();
        if (!this.add.disabled) this.main.click();
      });
      this.refresh = () => this.sync();
      this.info.addEventListener('change', this.refresh);
      this.info.addEventListener('variant:change', this.refresh);
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.info, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','aria-pressed','value','class']});
      if ('IntersectionObserver' in window) {
        this.intersection = new IntersectionObserver(entries => {
          const rect = entries[0].boundingClientRect;
          this.pastMain = !entries[0].isIntersecting && rect.bottom <= 0;
          this.sync();
        }, {threshold:0});
        this.intersection.observe(this.main);
      }
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          if (String(event.data?.sectionId) === this.dataset.section) {
            const data = event.data.html?.querySelector('[data-njt-purchase-variants]');
            if (data) { try { this.variants = JSON.parse(data.textContent); } catch (_) {} }
            this.sync();
          }
        });
      }
      this.sync();
    }
    arrangeDetails() {
      this.info.querySelectorAll('.lb-upsell-ppa-title-cont').forEach(container => {
        const title = container.querySelector('.lb-upsell-ppa-title');
        const description = container.querySelector('.lb-upsell-ppa-offer-desc');
        if (!title || !description) return;
        const text = node => node.textContent.replace(/\s+/g, ' ').trim();
        const duplicate = Boolean(text(title)) && text(title) === text(description);
        if (description.hidden !== duplicate) description.hidden = duplicate;
      });
      const row = this.form.querySelector('.njt-purchase-row');
      if (row) {
        if (this.main.parentElement !== row) row.append(this.main);
        const quantity = document.getElementById('Quantity-Form-' + this.dataset.section);
        if (quantity && quantity.parentElement !== row) row.prepend(quantity);
        [...row.children].forEach(child => {
          if (child !== quantity && child !== this.main) row.parentElement.append(child);
        });
      }
      const pickup = this.info.querySelector('[data-njt-pickup-card]');
      const details = this.info.querySelector('.njt-pickup-block');
      if (pickup && details && details.parentElement !== pickup) pickup.append(details);
      this.info.querySelectorAll('.swym-add-to-wishlist, .swym-button-bar button.swym-button').forEach(button => {
        const saved = button.classList.contains('swym-added') || button.getAttribute('aria-pressed') === 'true';
        const label = saved ? this.labels.saved : this.labels.save;
        if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
        if (!button.classList.contains('njt-save-button')) button.classList.add('njt-save-button');
        let text = button.querySelector('.njt-save-label');
        if (!text) { text = document.createElement('span'); text.className = 'njt-save-label'; button.append(text); }
        if (text.textContent !== label) text.textContent = label;
      });
    }
    sync() {
      this.arrangeDetails();
      const blocked = this.main.disabled || this.main.getAttribute('aria-disabled') === 'true' || this.main.classList.contains('loading');
      this.add.disabled = blocked;
      this.add.textContent = this.main.querySelector('span')?.textContent.trim() || this.main.textContent.trim();
      const price = this.info.querySelector('.price--on-sale .price-item--sale') || this.info.querySelector('.price-item--regular');
      this.price.textContent = price?.textContent.trim() || '';
      this.bar.hidden = !this.pastMain;
      document.body.classList.toggle('njt-has-purchase-bar', Boolean(this.pastMain));
      const variant = this.variants.find(v => String(v.id) === this.form.querySelector('[name="id"]')?.value);
      const freeShipping = this.info.querySelector('[data-njt-free-shipping]');
      if (freeShipping) {
        const shippingMessage = !variant || this.dataset.currency !== 'CAD'
          ? freeShipping.dataset.checkout
          : variant.price > 35000 ? freeShipping.dataset.qualified : freeShipping.dataset.threshold;
        if (freeShipping.textContent !== shippingMessage) freeShipping.textContent = shippingMessage;
      }
      const noStock = !variant || this.main.disabled || Boolean(variant.managed && variant.quantity <= 0);
      const promo = this.info.querySelector('[data-njt-shipping-promo]');
      const alert = this.info.querySelector('[data-njt-stock-alert]');
      const stockText = this.info.querySelector('[data-njt-stock-text]');
      if (promo) promo.hidden = noStock;
      if (alert) alert.hidden = !noStock;
      if (stockText) {
        const status = !variant || this.main.disabled ? stockText.dataset.sold : stockText.dataset.order;
        if (stockText.textContent !== status) stockText.textContent = status;
      }
      this.info.querySelectorAll('.njt-live-inventory, .product__inventory').forEach(node => { node.hidden = noStock; });
      const pickup = this.info.querySelector('[data-njt-pickup-card]');
      const copy = this.info.querySelector('[data-njt-delivery-copy]');
      if (pickup) pickup.hidden = this.dataset.liveInventory !== 'true' || !variant || variant.quantity <= 0 || this.main.disabled;
      const pickupChoice = pickup?.querySelector('.njt-method-radio');
      if (pickupChoice) {
        if (pickupChoice.disabled !== (pickup.hidden || blocked)) pickupChoice.disabled = pickup.hidden || blocked;
        // Keep the selected method during loading; reset only when pickup is unavailable.
        if (pickup.hidden && pickupChoice.checked) {
          pickupChoice.checked = false;
          const deliveryChoice = this.info.querySelector('[data-njt-method-card="Delivery"] input');
          if (deliveryChoice) deliveryChoice.checked = true;
        }
      }
      const deliveryChoice = this.info.querySelector('[data-njt-method-card="Delivery"] input');
      if (deliveryChoice && deliveryChoice.disabled !== blocked) deliveryChoice.disabled = blocked;
      const message = this.main.disabled ? this.labels.unavailable : variant?.managed && variant.quantity <= 0 ? this.labels.delayed : this.labels.ready;
      if (copy && copy.textContent !== message) copy.textContent = message;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.intersection?.disconnect();
      this.unsubscribe?.();
      this.info?.removeEventListener('change',this.refresh);
      this.info?.removeEventListener('variant:change',this.refresh);
      document.body.classList.remove('njt-has-purchase-bar');
    }
  }
  customElements.define('njt-product-purchase', ProductPurchase);
  function initRecommendations() {
    document.querySelectorAll('.njt-recommendations').forEach(section => {
      if (section.dataset.njtReady) return;
      section.dataset.njtReady = 'true';
      const filter = () => {
        let vehicle = new URL(location.href).searchParams.get('filter.p.m.organizer.car_models') || '';
        if (!vehicle) { try { vehicle=JSON.parse(localStorage.getItem('gta-global-vehicle-filter') || 'null')?.vehicleName || ''; } catch (_) {} }
        const items = [...section.querySelectorAll('[data-njt-recommendation]')];
        for (const item of items) {
          let vehicles = [];
          try { vehicles=JSON.parse(item.dataset.vehicles || '[]') || []; } catch (_) {}
          item.hidden = Boolean(vehicle) && item.dataset.universal !== 'true' && !(Array.isArray(vehicles) && (vehicles.includes(vehicle) || vehicles.includes('ALL VEHICLES')));
          item.querySelectorAll('a[href*="/products/"]').forEach(link => {
            const url=new URL(link.href,location.origin);
            if (vehicle) url.searchParams.set('filter.p.m.organizer.car_models',vehicle);
            else url.searchParams.delete('filter.p.m.organizer.car_models');
            link.href=url.href;
          });
        }
        section.hidden = items.length > 0 && items.every(item=>item.hidden);
      };
      new MutationObserver(filter).observe(section,{childList:true,subtree:true});
      document.addEventListener('njt:vehicle-state',filter);
      section.addEventListener('click', event => {
        const button=event.target.closest('[data-njt-related-prev],[data-njt-related-next]');
        if (!button) return;
        const list=section.querySelector('.product-grid');
        const item=list?.querySelector('[data-njt-recommendation]:not([hidden])');
        if (item) list.scrollBy({left:(item.getBoundingClientRect().width+16)*(button.hasAttribute('data-njt-related-prev')?-1:1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      });
      filter();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initRecommendations); else initRecommendations();
})();
